import styled from 'styled-components';
import React from 'react';

import { Link } from '@pb/shared/ui/atoms/link';
import { Container } from '@pb/shared/ui/atoms/container';
import { ButtonIcon } from '@pb/shared/ui/atoms/button-icon';
export const StyledAccountNavBar = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 5.6rem;
    background-color: ${({ theme }) => theme.color.white};
    border-bottom: 0.1rem solid ${({ theme }) => theme.color.grey4};
`;

export const StyledContainer = styled(Container)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 4.8rem;
    max-height: 4.8rem;

    @media (max-width: ${({ theme }) =>
            theme.deprecatedScreen.tabletPortraitMaximum}) {
        padding-right: 0.8rem;
    }
`;

export const StyledLogoContainer = styled.span`
    display: flex;
    align-items: center;

    @media (max-width: ${({ theme }) =>
            theme.deprecatedScreen.tabletPortraitMaximum}) {
        margin-left: -1.2rem;
    }
`;

export const StyledList = styled.ul`
    display: flex;
    padding-left: 0;
    list-style: none;
`;

export const StyledListItems = styled.li`
    position: relative;
    padding: 0 0.4rem;
`;

export const StyledIconWrapper = styled.div`
    position: absolute;
    top: -0.4rem;
    right: 0.4rem;
`;

export const StyledLogoLink = styled(properties => <Link {...properties} />)`
    && a {
        &:focus {
            outline: 0.3rem solid ${({ theme }) => theme.color.purple};
            outline-offset: 0.2rem;
            box-shadow: none;
        }
    }
`;

export const StyledButtonIcon = styled(properties => (
    <ButtonIcon {...properties} />
))`
    @media (max-width: ${({ theme }) =>
            theme.deprecatedScreen.tabletPortraitMaximum}) {
        display: flex;
        margin-right: 0.4rem;
    }
`;
